import { styled } from '@linaria/react';

export default styled.code`
  font-size: 1rem;
  font-family: var(--font-family-mono);
  background: var(--color-gray-200);
  padding: 2px 8px 4px;
  border-radius: 4px;
  text-align: left;
`;
